import React, { Component } from "react";
import { connect } from "react-redux";
import { hideFlashMessage } from "Actions";

import FlashMessageComponent from "./FlashMessageComponent";

class FlashMessage extends Component {
  componentDidUpdate() {
    const { hideFlashMessage } = this.props;
    setTimeout(() => {
      hideFlashMessage();
    }, 5000);
  }
  render() {
    //const { code, openFlash, message } = this.props;
    return <FlashMessageComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({
  message: state.params.flashMessage.message,
  status: state.params.flashMessage.status,
  openFlash: state.params.flashMessage.openFlash
});

const mapDispatchToProps = dispatch => ({
  hideFlashMessage: () => dispatch(hideFlashMessage())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessage);



// WEBPACK FOOTER //
// ./src/components/Layout/FlashMessage/index.js